import React, { Component } from "react";
import TranslatedPage from "../../containers/TranslatedPage";

import Logo from "../../styles/images/logo.svg";
import CircleImage from "../Image/CircleImage";
import UserDecorator from "../../containers/UserDecorator/UserDecorator";
// import "./CirclePrintGiftCard.scss";
import QRCode from "qrcode.react";

const User = ({ user }) => {
  return (
    <div className="gift-details">
      — {user.f_name}
    </div>
  );
};

export default class PrintableGiftcard extends Component {
  render() {
    return (
      <div className="gift-card-print-image">
        <div className="main-side">
          <div className="user-message">
            <TranslatedPage path="whitemonday.content_blocks.print_gift_card_message.heading" />

            <div className="content">
              <TranslatedPage path="whitemonday.content_blocks.print_gift_card_message.subheading" />
              <div className="circle-name">&nbsp;"{this.props.circle.products[0].name}".&nbsp;</div>
              <TranslatedPage path="whitemonday.content_blocks.print_gift_card_message.content" />
            </div>

            <div className="user-name">
              <UserDecorator userId={this.props.circle.created_by}>
                <User />
              </UserDecorator>
              .
            </div>
          </div>
        </div>
        <div className="secondary-side">
          <div className="product-showcase">
            <div className="print-product-details">
              <div className="image-qr">
                <div className="product-image">
                  <CircleImage
                    size="small"
                    src={this.props.circle.products[0].image_url}
                    alt={this.props.circle.products[0].name}
                  />
                </div>
                <div className="qr-code">
                  <QRCode value={this.props.circleUrl} includeMargin={false} />
                </div>
              </div>
              <div className="product-meta">
                <div className="circle-name">{this.props.circle.products[0].name}</div>
                <div className="circle-copy">
                  <TranslatedPage path="whitemonday.content_blocks.print_gift_card_about.heading" />
                </div>
              </div>
            </div>
          </div>
          <div className="about-ihopa">
            <TranslatedPage path="whitemonday.content_blocks.print_gift_card_about.content" />
            <div className="logo">
              <img src={Logo} alt="ihopa logo" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
